import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, HideScrollbar } from '../../../../global/commonStyle';

const Main = styled.div`
  display: flex;
  flex-direction: column;
  ${mobile_xl(css`
    height: calc(100dvh - 40px);
  `)};
`;
const Header = styled.div`
  ${FlexBetween}
  padding: var(--space-10) var(--space-14);
  ${mobile_xl(css`
    padding-inline: var(--space-20);
  `)};
`;

const LeftHeader = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
`;
const RightHeader = styled.div`
  display: flex;
  gap: var(--space-16);
`;
const Dates = styled.div`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
`;
const Icon = styled.div`
  display: flex;
`;

const Cards = styled.div`
  display: flex;
  padding-inline: var(--space-6);
  border-top: 0.5px solid var(--border-primary);
  ${HideScrollbar}
  ${mobile_xl(css`
    padding-inline: var(--space-12);
  `)}
`;

const CalendarCardWrapper = styled.div`
  cursor: grabbing;
`;

export { Main, Header, LeftHeader, RightHeader, Dates, Icon, Cards, CalendarCardWrapper };
